import React from "react";
import CaseStudy from "@/components/CaseStudy";
import PageCTA from "@/components/PageCTA";

const CaseStudyPage = () => (
  <div className="pt-24">
    <CaseStudy />
    <PageCTA
      heading="Your engine. Your outcome. Documented like this."
      sub="Every NEX engine ships with an audit-ready reporting layer — so when the results come, they're defensible."
      secondary={{ to: "/program", label: "See the 3-Phase Program" }}
    />
  </div>
);

export default CaseStudyPage;
